<template>
  <div class="product-list">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="场景名称">
          <el-input size="small" v-model="searchForm.sence_title" placeholder="请输入场景名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--添加产品-->
    <div class="common-level-rail" style="display:flex;">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加极光模板</el-button>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%">
          <el-table-column prop="sence_title" align="center" label="场景名称" width="120">
          </el-table-column>
          <el-table-column prop="status" label="状态" align="center" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.status==0"> 启用</div>
              <div v-if="scope.row.status==1"> 关闭</div>
            </template>
          </el-table-column>
          <el-table-column prop="sence_title" align="center" label="场景" width="120">
          </el-table-column>
          <el-table-column prop="sence.sence_name" align="center" label="场景" width="120">
          </el-table-column>
          <el-table-column prop="sence_content" align="center" label="场景内容" width="250">
          </el-table-column>
          <el-table-column prop="source.text" align="center" label="推送程序" width="120">
            <!-- <template slot-scope="scope">
              <div v-if="scope.row.source==1">小程序</div>
              <div v-if="scope.row.source==2">APP</div>
              <div v-if="scope.row.source==3">h5</div>
              <div v-if="scope.row.source==4">全部</div>
            </template> -->
          </el-table-column>
          <el-table-column prop="platform_type.text" align="center" label="手机类型" width="120">
            <!-- <template slot-scope="scope">
              <div v-if="scope.row.type==1">andiord</div>
              <div v-if="scope.row.type==2">ios</div>
              <div v-if="scope.row.type==3">全部</div>
            </template> -->
          </el-table-column>
          <el-table-column prop="" align="center" label="推送规则" width="180">
            <template slot-scope="scope">
              <div v-if="scope.row.push_type==2">自动推送</div>
              <div v-if="scope.row.push_type==1">手动推送</div>
            </template>
          </el-table-column>
          <el-table-column prop="push_time" align="center" label="推送时间" width="120" :formatter="formattedTime">
            <!-- <template slot-scope="scope">
              <div>{{formattedTime(scope.row.push_time)}}</div>
            </template> -->
          </el-table-column>
          <el-table-column prop="page" align="center" label="跳转页面" width="120">
          </el-table-column>
          <el-table-column prop="url" align="center" label="跳转路径" width="120">
          </el-table-column>

          <el-table-column prop="user_group" align="center" label="用户分组" width="120">
          </el-table-column>
          <el-table-column prop="user_type" align="center" label="所属分类" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.user_type==1">技师</div>
              <div v-if="scope.row.user_type==2">用户</div>
              <div v-if="scope.row.user_type==3">商家</div>
              <div v-if="scope.row.user_type==4">全部</div>
            </template>
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="220">
            <template slot-scope="scope">
              <div class="">
                <el-button @click="editClick(scope.row)" type="primary" size="small">编辑</el-button>
                <el-button :disabled="scope.row.push_type==2" @click="pushClick(scope.row)" type="success" size="small">推送</el-button>
                <el-button @click="delClick(scope.row)" type="danger" size="small">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
  </div>
</template>

<script>
import AppSettingApi from "@/api/appsetting.js";
export default {
  components: {
    // Add
  },
  data() {
    return {
      status: "", //是否显示
      tableData: [],
      open_add: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      searchForm: {
        sence_title: ""
      }
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    formattedTime(row, column) {
      const timestamp = row.push_time;

      var date = new Date(timestamp * 1000);
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    // 是否显示音乐
    pushClick(row) {
      let self = this;
      AppSettingApi.sendToMessage({
        template_id: row.template_id
      }).then(data => {
        self.$message({
          message: data.msg,
          type: "success"
        });
        self.getData();
      });
    },
    /*打开添加*/
    addClick() {
      this.$router.push("/appsetting/template/add");
    },
    // 详情
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      AppSettingApi.templateList(Params, true)
        .then(data => {
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },
    /*打开编辑*/
    editClick(row) {
      this.$router.push({
        path: "/appsetting/template/edit",
        query: {
          template_id: row.template_id,
          scene: "edit"
        }
      });
    },
    /*删除*/
    delClick: function(row) {
      let self = this;
      self
        .$confirm("确定删除该记录吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          AppSettingApi.templateDelete({
            template_id: row.template_id
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getData();
          });
        });
    }
  }
};
</script>

<style scoped  lang='scss'>
.s_flex {
  display: flex;
  justify-content: space-between;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/appsetting/template/index.vue